import React, { useEffect, useState } from "react";
import { getLocations, getStates, getDistricts, getTalukas } from "../../../apis/locations";
import { Button } from "../../../Components/Helper";
import {
  addDronePilot,
  getDronePilot,
  updateDronePilot,
} from "../../../apis/dronePilots";

import Popup from "../../../ReusableFunctions/Popup";
import Modal from "../../../ReusableComponents/Modal";
import { v4 as uuid } from "uuid"
import Loading from "../../../ReusableFunctions/Loader";
import InputField from "../../../ReusableComponents/InputField";
import { addressValidation, emailValidation, licenceValidation, nameValidation, pincodeValidation, selectFieldValidation } from "../../../utils/inputValidations";
import Form from "../../../ReusableComponents/Form";
import SelectField from "../../../ReusableComponents/SelectField";
import ToggleField from "../../../ReusableComponents/ToggleField";
import useWindowSize from "../../../hooks/useWindowSize";
import { getDSPDrones } from "../../../apis/drones";
import { SERVICE_TYPES } from "../../../appConstants";
import Select from 'react-select';
import { getName } from "country-list";

  import {
    getCountryCallingCode,
    getCountries,
    isValidPhoneNumber,
  } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { getToken } from "../../../apis/authentication";

const getEmojiFlag = (countryCode) =>
  countryCode
    .toUpperCase()
    .replace(/./g, (char) =>
      String.fromCodePoint(127397 + char.charCodeAt(0))
    );

const AddDronePilot = ({ open, onClose, pilotId, onPilotAdd, indianStates }) => {
  const [locations, setLocations] = useState([]);
  const { currentHeight, currentWidth } = useWindowSize();
  const [dspDrones, setDspDrones] = useState([])
  const [pilot, setPilot] = useState({
    id: pilotId ? pilotId : uuid(),
    first_name: "",
    middle_name: '',
    last_name: '',
    email: "",
    phone: "",
    first_line_address: "",
    second_line_address: "",
    state: '',
    city: '',
    pincode: '',
    aadhar_number: "",
    pan_number: "",
    licence_id: "",
    is_active: true,
    location_id: null,
    dsp_id: "",
    assigned_drone:undefined,
    date_created: new Date(),
  });
  const countryOptions = getCountries().map((country) => ({
    value: country, // e.g. "IN"
    label: `${getEmojiFlag(country)} +${getCountryCallingCode(country)}`
  }));

  const [selectedCountryOption, setSelectedCountryOption] = useState(
    countryOptions.find(opt => opt.value === "IN")
  );
  const [mobileError, setMobileError] = useState("");
  const [countryCode, setCountryCode] = useState(`+${getCountryCallingCode("IN")}`);
  const [countryName,setCountryName]=useState("India")
  const [statesLoading, setStatesLoading] = useState(false)
  const [states, setStates] = useState([])
  const [districtsLoading, setDistrictsLoading] = useState(false)
  const [districts, setDistricts] = useState([])
  const [talukasLoading, setTalukasLoading] = useState(false)
  const [talukas, setTalukas] = useState([])


  const validateField = (name, value, customCountryCode) => {
    let error = "";
    switch (name) {
      case "phone":
        if (!value) {
          error = "Phone number is required";
        } else {
          const codeToUse = customCountryCode || countryCode;
          const testFull = `${codeToUse}${value}`;
          if (!isValidPhoneNumber(testFull)) {
            error = "Invalid phone number for selected country";
          }
        }
        break;
      default:
        break;
    }
  
    setMobileError(error);
    return !error;
  };
  const handlePhoneChange = (e) => {
    const localNumber = e.target.value.replace(/\D/g, '');
    handleChange("phone", localNumber);
  };

  const handleChange = (name, value) => {
    setPilot((prev) => ({ ...prev, [name]: value }));
    validateField(name, value, countryCode);
  };


  const handleCountryChange = (option) => {
    setStates([]);
    setSelectedCountryOption(option);
    const countryName = getName(option.value);
    setCountryName(countryName);
    const newCode = `+${getCountryCallingCode(option.value)}`;

    setCountryCode(newCode);
    validateField("phone", pilot.phone, newCode);
     getStatesFunc(undefined, "", option.value);
  };

  const handleAddDronePilot = (pilot) => {
    Loading.set(true)
    addDronePilot(pilot)
      .then((res) => {
        Loading.set(false)
        Popup.alert("Drone Pilot", "Pilot added successfully", "SUCCESS");
        onPilotAdd({ ...pilot, location_name: locations.find((l) => l.id === pilot?.location_id)?.name })
      })
      .catch((err) => {
        console.log(err);
        Loading.set(false)
        Popup.alert("Error", err.errorMessage, "ERROR");
      });
  };

  const handleUpdateDronePilot = (pilot) => {

   
    Loading.set(true)
    updateDronePilot(pilot)
      .then((res) => {
        Loading.set(false)
        Popup.alert(
          "Drone Pilot",
          "Pilot updated successfully",
          "SUCCESS"
        )
        onPilotAdd({ ...pilot, location_name: locations.find((l) => l.id === pilot?.location_id)?.name })
      })
      .catch((err) => {
        console.log(err);
        Loading.set(false)
        Popup.alert("Error", err.errorMessage, "ERROR");
      });
  };


  const getStatesFunc = async (countryId=undefined,countryName="",countryISOCode="") => {
    try {
      setStatesLoading(true)
      setDistricts([])
      setTalukas([])
        const url = `${process.env.REACT_APP_API_URL}/dsp/countries/states/${countryId}?countryName=${countryName}&countryISOCode=${countryISOCode}`;
              const response = await fetch(url,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getToken()}`,
                  },
                }
              );
              if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      const data = await response.json();
      setStates(data?.states || []);
      // }
      setStatesLoading(false)
    } catch (err) {
      setStatesLoading(false)
      console.log(err);
      Popup.alert("Error", err.errorMessage, "ERROR");
    }
  }

  const getDistrictsFunc = async (stateCode, stateName) => {
    try {
      setDistrictsLoading(true)
      setTalukas([])
        const url = `${process.env.REACT_APP_API_URL}/dsp/countries/states/cities/${stateCode}?stateName=${encodeURIComponent(stateName)}`;
              const response = await fetch(url,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getToken()}`,
                  },
                }
              );
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              const data = await response.json();
              setDistricts(data?.cities || []);
      setDistrictsLoading(false)
    } catch (err) {
      setDistrictsLoading(false)
      console.log(err);
      Popup.alert("Error", err.errorMessage, "ERROR");
    }
  }

  const getTalukasFunc = async (districtCode, districtName) => {
    try {
      setTalukasLoading(true)
      const talukas = await getTalukas(districtCode, districtName)
      setTalukas(talukas?.records)
      setTalukasLoading(false)
    } catch (err) {
      setTalukasLoading(false)
      console.log(err);
      Popup.alert("Error", err.errorMessage, "ERROR");
    }
  }

  const getDrones = async () => {
    try {
      const dspDrones = await getDSPDrones()
      setDspDrones(dspDrones)
      return dspDrones; 
    } catch (e) {
      throw (e)
    }
  }
  const handleDroneSelection = (e) => {
    const label = e.label;
    const value=e.value;
    setPilot({ ...pilot, assigned_drone: label,drone_id:value })
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      Loading.set(true);
      let drones = await getDrones();
      const locations = await getLocations();
      await getStatesFunc(undefined, countryName);
      setLocations(locations);
  
      if (pilotId) {
        const res = await getDronePilot(pilotId);
        const pilotData = res.dronePilot;
        const drone = drones.find((d) => d.id === pilotData.drone_id);
        
        // Set country code first
        if (pilotData.country_code) {
          const numericCode = pilotData.country_code.replace('+', '');
          const matched = countryOptions.find(opt => getCountryCallingCode(opt.value) === numericCode);
          if (matched) {
            setSelectedCountryOption(matched);
            const newCode = `+${numericCode}`;
            setCountryCode(newCode);
            // Validate with the new country code immediately
            validateField("phone", pilotData.phone, newCode);
          }
        }
        await getStatesFunc(undefined,pilotData.country);
        await getDistrictsFunc(null, pilotData.state);
        setPilot((prev) => ({
          ...prev,
          ...pilotData,
          assigned_drone: drone?.drone_uin,
          drone_id: drone?.id,
          state: { label: pilotData.state, value: pilotData.state },
          district: { label: pilotData.district, value: pilotData.district },
          city: { label: pilotData.city, value: pilotData.city },
          location_id: locations.find(loc => loc.id === pilotData.location_id)
            ? { value: pilotData.location_id, label: locations.find(loc => loc.id === pilotData.location_id).name }
            : null
        }));
      } else {
        validateField("phone", ""); // Show error initially if no phone
      }
      Loading.set(false);
    }
    fetchInitialData().catch(err => console.log(err));
  }, [pilotId]);


  const isNonIndianNumber = countryCode && countryCode !== "+91";
  console.log('isNonIndianNumber: ', isNonIndianNumber);


  return (
    <Modal
      header={pilotId ? "Edit Pilot" : "Add Pilot"}
      open={open}
      onClose={onClose}
      contentStyle={{ width: "735px", height: "auto", borderRadius: "10px" }}
      headerContainerStyle={{ padding: currentHeight < 695 ? "20px 30px" : "25px 30px" }}
    >
      <Form
        onSubmitForm={(pilot) => {
            // always validate phone before submitting
             validateField("phone", pilot.phone);
            
            if (mobileError) {
              return;
            }
          pilot = { ...pilot,country_code:countryCode?countryCode.split("+")[1]:null, country: countryName, city: pilot.city?.label, district: pilot.district?.label, state: pilot.state?.label, location_id: pilot.location_id?.value };
          pilotId ? handleUpdateDronePilot(pilot) : handleAddDronePilot(pilot)
        }}
        initialValues={pilot}
      >
        {(onsubmit) => (
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: currentHeight < 695 ? "2px" : "5px",
            padding: currentHeight < 695 ? "15px 20px" : "20px",

          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <InputField
                defaultValue={pilot.first_name}
                label={"First name"}
                type={"text"}
                id={"type"}
                placeholder={"first name"}
                name={"first_name"}
                validation={nameValidation}
                containerStyle={{
                  width: "30%",
                  maxWidth: "30%",
                  minHeight: "80px",
                }}
                handleChange={(value) => {
                  setPilot((prev) => ({ ...prev, first_name: value }))
                }}
              />
              <InputField
                defaultValue={pilot.middle_name}
                label={"Middle name"}
                type={"text"}
                id={"type"}
                placeholder={"middle name"}
                name={"middle_name"}
                containerStyle={{
                  width: "30%",
                  maxWidth: "30%",
                  minHeight: "80px",
                }}
                validation={{
                  ...nameValidation,
                  required: {
                    value: false,
                    message: '',
                  },
                  validate: () => {
                    return true;
                  }
                }}
                handleChange={(value) => {
                  setPilot((prev) => ({ ...prev, middle_name: value }))
                }}
              />
              <InputField
                defaultValue={pilot.last_name}
                label={"Last Name"}
                type={"text"}
                id={"type"}
                placeholder={"last name"}
                name={"last_name"}
                containerStyle={{
                  width: "30%",
                  maxWidth: "30%",
                  minHeight: "80px",
                }}
                validation={nameValidation}
                handleChange={(value) => {
                  setPilot((prev) => ({ ...prev, last_name: value }))
                }}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <InputField
            defaultValue={pilot.id_proof}
            label={"ID Proof"}
            type={"text"}
            id={"type"}
            placeholder={"Pilot ID"}
            name={"id_proof"}
            containerStyle={{
              width: "30%",
              maxWidth: "30%",
              minHeight: "80px",
            }}
            validation={{
              required: {
                value: false,
                message: '',
              },
              pattern: {
                value: /^[a-zA-Z0-9]*$/,   // allows only alphanumeric
                message: "ID Proof must be alphanumeric",
              },
              maxLength: {
                value: 10,
                message: "ID Proof must be at most 10 characters",
              },
            }}
            handleChange={(value) => {
              setPilot((prev) => ({ ...prev, id_proof: value }))
            }}
          />

              
              <InputField
                defaultValue={pilot.licence_id}
                label={"License ID"}
                type={"text"}
                id={"type"}
                placeholder={"Pilot license id"}
                name={"licence_id"}
                containerStyle={{
                  width: "30%",
                  maxWidth: "30%",
                  minHeight: "80px",
                }}
                validation={{...licenceValidation,
                  required: {
                    value: false,
                    message: '',
                  },}}
                handleChange={(value) => {
                  setPilot((prev) => ({ ...prev, licence_id: value }))
                }}
              />
               <div style={{
                width: '30%',
                paddingTop: '4px'
              }}>
                <SelectField
                  name={"location_id"}
                  label={"Location"}
                  list={locations?.map(location => ({ value: location.id, label: location.name }))}
                  styles={{ width: "215px", height: "18px", fontSize: "13px", margin: "0 0 0 -1px" }}
                  validation={{
                    ...selectFieldValidation,
                    required: {
                      value: false,
                      message: '',
                    },
                  }}
                  containerStyle={{
                    width: "100%",
                    maxWidth: "100%",
                    minHeight: "80px"
                  }}
                  handleChange={(value) => {
                    setPilot((prev) => ({
                      ...prev,
                      location_id: value
                    }))
                  }}
                />
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center",}}>
              <div style={{width:"45%",marginTop:"-10px"}}>
              <label htmlFor="phone" style={{
                fontSize:"12px",marginTop:"-5px",
              }}>
            Phone
          </label>
          <div style={{
            display: "flex", alignItems: "center",
            border:  "1px solid #D0D5DD",
            borderRadius: "4px", width: "100%", height: "35px"
          }}>
            {/* react-select country code */}
            <Select
              value={selectedCountryOption}
              onChange={handleCountryChange}
              options={countryOptions}
              isSearchable
              styles={{
                control: (provided) => ({
                  ...provided, minWidth: "100px", maxWidth: "150px",background:"#F3F3F3",
                  height: "85%", fontSize: "14px", border: "none", boxShadow: "none"
                }),
                menu: (provided) => ({
                  ...provided, maxHeight: "150px", overflowY: "auto"
                })
              }}
            />
            <div style={{ width: "1px", height: "40%",}} />
            <input
              type="text"
              placeholder="Enter pilot's mobile number"
              value={pilot.phone}
              onChange={handlePhoneChange}
              style={{ flex: 1, border: "none",backgroundColor: "#F3F3F3" , outline: "none", padding: "0 12px", height: "100%", fontSize: "14px" }}
            />
          </div>
          <span style={{ 
            color: "#D92D20", 
            fontSize: "12px", 
            height: "16px",     // fixed height instead of minHeight
            display: "block",
            overflow: "hidden"
          }}>
            {mobileError}
          </span>
              </div>
              <div style={{
                width:"45%"
              }} >

              <InputField
                defaultValue={pilot.email}
                label={"Email"}
                type={"text"}
                id={"type"}
                placeholder={"Pilot email"}
                name={"email"}
                containerStyle={{
                  width: "100%",
                  maxWidth: "100%",
                  minHeight: "80px"
                }}
                validation={{
                  ...emailValidation,
                  required: {
                    value: isNonIndianNumber,
                    message: isNonIndianNumber ? "Email is required" : "",
                  },
                }}
                handleChange={(value) => {
                  setPilot((prev) => ({ ...prev, email: value }))
                }}
              />
              </div>
             
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: "48%" }}>
                <InputField
                  defaultValue={pilot.first_line_address}
                  label={"First line address"}
                  type={"text"}
                  id={"type"}
                  placeholder={"First line address"}
                  name={"first_line_address"}
                  containerStyle={{
                    width: "100%",
                    maxWidth: "100%",
                    minHeight: "80px"
                  }}
                  validation={{
                    ...addressValidation,
                    required: {
                      value: false,
                      message: '',
                    },
                  }}
                  handleChange={(value) => {
                    setPilot((prev) => ({ ...prev, first_line_address: value }))
                  }}
                />
              </div>
              <div style={{ width: "48%" }}>
                <InputField
                  defaultValue={pilot.second_line_address}
                  label={"Second line address"}
                  type={"text"}
                  id={"type"}
                  containerStyle={{
                    width: "100%",
                    maxWidth: "100%",
                    minHeight: "80px"
                  }}
                  placeholder={"Second line address"}
                  name={"second_line_address"}
                  validation={{
                    ...addressValidation,
                    required: {
                      value: false,
                      message: '',
                    }
                  }}
                  handleChange={(value) => {
                    setPilot((prev) => ({ ...prev, second_line_address: value }))
                  }}
                />
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{width:  "48%" }}>
                <SelectField
                  name={"state"}
                  label={"State"}
                  isLoading={statesLoading}
                  isDisabled={statesLoading}
                  list={states?.map(state => ({ value: state.name, label:  state.name }))}
                  styles={{ width: "215px", height: "18px", fontSize: "13px", margin: "0 0 0 -1px" }}
                  validation={{...selectFieldValidation,required: {
                    value: false,
                    message: '',
                  }}}
                  handleChange={(state) => {
                    if (state?.value || typeof state?.value == "number") {
                      getDistrictsFunc(undefined, state?.label);
                    }
                    setPilot((prev) => ({
                      ...prev,
                      state: state,
                      district: null,
                      city: null
                    }))
                  }}
                  containerStyle={{
                    width: "100%",
                    maxWidth: "100%",
                    minHeight: "80px"
                  }}
                  isSearchable={true}
                />
              </div>
              <div style={{ width: "48%" }}>
                <SelectField
                  name={"city"}
                  isLoading={districtsLoading}
                  isDisabled={districtsLoading}
                  label={"City"}
                  list={districts?.map(city => ({ value: city?.id, label: city?.name }))}
                  styles={{ width: "215px", height: "18px", fontSize: "13px", margin: "0 0 0 -1px" }}
                  validation={{...selectFieldValidation,required: {
                    value: false,
                    message: '',
                  }}}
                  handleChange={(selected) => {
                    // if (selected?.value && typeof selected?.value == "number") {
                    //   getTalukasFunc(selected?.value)
                    // }
                    setPilot((prev) => ({
                    ...prev,
                    ...({ city: selected, district: null })
                  }));
                  }}
                  isSearchable={true}
                  containerStyle={{
                    width: "100%",
                    maxWidth: "100%",
                    minHeight: "80px"
                  }}
                />
              </div>  

          {/* <div style={{ width: "48%" }}>
                <SelectField
                  name={"city"}
                  isLoading={talukasLoading}
                  isDisabled={talukasLoading}
                  label={"City"}
                  list={talukas?.map(city => ({ value: city?.subdistrict_code, label: city?.subdistrict_name_english }))}
                  styles={{ width: "215px", height: "18px", fontSize: "13px", margin: "0 0 0 -1px" }}
                  validation={{...selectFieldValidation,required: {
                    value: false,
                    message: '',
                  },}}
                  isSearchable={true}
                  containerStyle={{
                    width: "100%",
                    maxWidth: "100%",
                    minHeight: "80px"
                  }}
                  handleChange={(taluka) => {
                    setPilot((prev) => ({
                      ...prev,
                      city: taluka
                    }))
                  }}
                />
              </div> */}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width:  "48%" }}>
                <InputField
                  defaultValue={pilot.pincode}
                  label={"Pincode / Postal Code"}
                  type={"text"}
                  id={"type"}
                  placeholder={"pincode"}
                  name={"pincode"}
                  containerStyle={{
                    width: "100%",
                    maxWidth: "100%",
                    minHeight: "80px"
                  }}
                  validation={{...pincodeValidation,required: {
                    value: false,
                    message: '',
                  },}}
                  handleChange={(value) => {
                    setPilot((prev) => ({ ...prev, pincode: value }))
                  }}
                />
              </div>
              <div style={{ width:  "48%" }}>
                <SelectField
                  name={"assigned_drone"}
                  label={"Assign Drone"}
                  value={pilot.assigned_drone ? { value: pilot.drone_id, label: pilot.assigned_drone } : ""}
                  list={dspDrones?.filter((d) => d?.service_type === SERVICE_TYPES[0] || d?.service_type==="Spraying service").map(el => ({ value: el.id, label: el.drone_uin }))}
                  styles={{ width: "215px", height: "18px", fontSize: "13px", margin: "0 0 0 -1px" }}
                  isSearchable={true}
                  containerStyle={{
                    width: "100%",
                    maxWidth: "100%",
                    minHeight: "80px"
                  }}
                  validation={{...selectFieldValidation,required: {
                    value: false,
                    message: '',
                  },}}
                  handleChange={handleDroneSelection}
                />
              </div>
            </div>
            <div>
              <ToggleField
                label={"Status"}
                name={"is_active"}
                onText={"Active"}
                offText={"Inactive"}
                defaultValue={pilot.is_active}
                handleChange={(e) => {
                  setPilot((prev) => ({ ...prev, is_active: e.target.checked }))
                }}
              />
            </div>
            <div style={{
              display: "flex",
              flexDirection: "row-reverse",
              gap: "20px",
              padding: currentHeight < 695 ? "10px" : "20px",
              height: "70px"
            }}>
              <Button
                text={pilotId ? "Update" : "Add"}
                onClick={onsubmit}
                className={"btn-large"}
              />
              <Button
                className={"btn-large lg-cancel-btn"}
                text={"Cancel"}
                onClick={onClose}
                isBtnNotActive={true}
              />
            </div>
          </div>
        )}
      </Form>
    </Modal >
  );
};

export default AddDronePilot;
